export default __webpack_public_path__ + "static/media/close-white.1fcaa42b.svg";